export interface SubscriptionModule {
  id: number;
  name: string;
  abbreviation: string;
}

export interface LookupTableItem {
  id: string;
  name: string;
  description?: string;
  short_code?: string;
}

export enum LookupTableItemKeys {
  ID = "id",
  NAME = "name",
  SHORT_CODE = "short_code",
}

export interface NestedLookupTableItem extends LookupTableItem {
  // Only single level children are expected
  children?: LookupTableItem[];
}

export enum NestedLookupTableItemKeys {
  ID = "id",
  NAME = "name",
  CHILDREN = "children",
}

// Commented out lines are included in response, but not yet utilized in front-end app
export enum LookupTablesKeys {
  // Tables that are used in same format returned from backend
  // TODO: not all of these are utilized in FE, compare with API and clean up both
  EDITORIAL_GROUPS = "editorialGroups",
  STATES = "states",
  COUNTRIES = "countries",
  PRIMARY_PROFILE_TYPES = "primaryProfileTypes",
  SECONDARY_PROFILE_TYPES = "secondaryProfileTypes",
  // POSITION_STATUSES = "positionStatuses",
  GENDERS = "genders",
  FOCUS_AREAS = "focusAreas",
  POLITICAL_PARTIES = "politicalParties",
  MARITAL_STATUSES = "maritalStatuses",
  ETHNICITIES = "ethnicities",
  RELIGIONS = "religions",
  // INDUSTRIES = "industries",
  DEGREES = "degrees",
  APPOINTMENTS = "appointments",
  JOB_CATEGORIES = "jobCategories",
  JOB_CATEGORIES_FEDERAL = "jobCategoriesFederal",
  // KEY_POLICY_AREAS = "keyPolicyAreas",

  // Flattened nested lookup tables, some lists are post-processed for frontend indexing purposes
  // TODO: some of these should not be labeled as _FLAT, move to above list
  PROFILE_TYPES_FLAT = "profileTypesFlat",
  KEY_POLICY_AREAS_FLAT = "keyPolicyAreasFlat",
  INDUSTRIES_FLAT = "industriesFlat",
  COMMITTEES_FLAT = "committeesFlat",
  CAUCUSES_FLAT = "caucusesFlat",
  AGENCIES_FLAT = "agenciesFlat",
  SPECIAL_INTEREST_GROUPS_FLAT = "specialInterestGroupsFlat",

  // Birthdate tables
  BIRTH_YEAR_OPTIONS = "birthYearOptions",
  BIRTH_YEAR_OPERATOR = "birthYearOperator",
  AGE_OPTIONS = "ageOptions",
  AGE_OPERATOR = "ageOperator",

  // Special Interest Groups tables
  SIG_OPERATOR = "sigOperator",
  SIG_RATING_OPTIONS = "sigRatingOptions",
}

export interface LookupTables {
  agenciesFlat: LookupTableItem[];
  appointments: LookupTableItem[];
  caucusesFlat: LookupTableItem[];
  committeesFlat: LookupTableItem[];
  countries: LookupTableItem[];
  degrees: LookupTableItem[];
  editorialGroups: LookupTableItem[];
  ethnicities: LookupTableItem[];
  focusAreas: LookupTableItem[];
  genders: LookupTableItem[];
  industries: LookupTableItem[];
  industriesFlat: LookupTableItem[];
  jobCategories: LookupTableItem[];
  jobCategoriesFederal: LookupTableItem[];
  keyPolicyAreasFlat: LookupTableItem[];
  maritalStatuses: LookupTableItem[];
  politicalParties: LookupTableItem[];
  positionStatuses: LookupTableItem[];
  primaryProfileTypes: LookupTableItem[];
  profileTypesFlat: LookupTableItem[];
  religions: LookupTableItem[];
  secondaryProfileTypes: LookupTableItem[];
  specialInterestGroupsFlat: LookupTableItem[];
  states: LookupTableItem[];
  subscriptionModules: SubscriptionModule[];

  // Computed
  ageOperator: LookupTableItem[];
  ageOptions: LookupTableItem[];
  birthYearOperator: LookupTableItem[];
  birthYearOptions: LookupTableItem[];
  sigOperator: LookupTableItem[];
  sigRatingOptions: LookupTableItem[];
}

export enum NestedLookupTablesKeys {
  PROFILE_TYPES = "profileTypes",
  KEY_POLICY_AREAS = "keyPolicyAreas",
  INDUSTRIES = "industries",
  COMMITTEES = "committees",
  CAUCUSES = "caucuses",
  AGENCIES = "agencies",
  SPECIAL_INTEREST_GROUPS = "specialInterestGroups",
}

export interface NestedLookupTables {
  profileTypes: NestedLookupTableItem[];
  keyPolicyAreas: NestedLookupTableItem[];
  industries: NestedLookupTableItem[];
  committees: NestedLookupTableItem[];
  caucuses: NestedLookupTableItem[];
  agencies: NestedLookupTableItem[];
  specialInterestGroups: NestedLookupTableItem[];
}
